import React, { FunctionComponent, useState, useLayoutEffect } from "react";
import * as echarts from "echarts/core";
import {
  DatasetComponent,
  DatasetComponentOption,
  TooltipComponent,
  TooltipComponentOption,
  GridComponent,
  GridComponentOption,
  LegendComponent,
  LegendComponentOption,
} from "echarts/components";
import { BarChart, BarSeriesOption } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([DatasetComponent, TooltipComponent, GridComponent, LegendComponent, BarChart, CanvasRenderer]);

type EChartsOption = echarts.ComposeOption<
  DatasetComponentOption | TooltipComponentOption | GridComponentOption | LegendComponentOption | BarSeriesOption
>;

let initOption: EChartsOption = {
  // tooltip: {},
  dataset: {
    source: [],
  },
  yAxis: {
    type: "category",
    axisLabel: {
      fontSize: 10,
      color: "#333333",
    },
    axisLine: {
      lineStyle: {
        color: "#BBBBBB",
      },
    },
  },
  xAxis: {},
  series: [],
};

interface IProps {
  dataSource: any;
  width: number;
  height: number;
  id: string;
  name?: string;
  visibleKeys: string[];
}

const SuperTestBarChart: FunctionComponent<IProps> = ({ id, dataSource, width, height, name, visibleKeys }) => {
  const [option, setOption] = useState<EChartsOption>(initOption);

  const createLinearGradient = (inx) => {
    let index = inx > 4 ? 4 : inx;

    return new echarts.graphic.LinearGradient(
      0,
      0,
      1,
      0,
      [
        {
          offset: 0,
          color: "#61DAFF",
        },
        {
          offset: 1,
          color: "#3264FF",
        },
      ],
      false,
    );
  };

  const initChart = () => {
    const chartDom = document.getElementById(id)!;
    const myChart = echarts.init(chartDom);

    option && myChart.setOption(option);
  };

  const initOptionFn = () => {
    const option = {
      // legend: {},
      // tooltip: {},
      dataset: {
        source: [],
      },
      yAxis: {
        type: "category",
        axisLabel: {
          fontSize: 12,
          color: "#333333",
        },
        axisLine: {
          lineStyle: {
            color: "#BBBBBB",
          },
        },
      },
      xAxis: {},
      series: [{ type: "bar" }],
      grid: {
        x: 100,
        y: 20,
        x2: 30,
        y2: 35,
      },
    };

    option.dataset.source = dataSource;
    option.series = new Array(dataSource?.[0].length - 1).fill(0).map((_, inx) => ({
      type: "bar",
      label: {
        show: true,
        position: "insideRight",
        color: "#fff",
        formatter: "{@[1]}km/L",
      },
      itemStyle: {
        color: createLinearGradient(inx),
      },
      barWidth: new Array(dataSource?.[0].length - 1).fill(0).length <= 2 ? "30px" : "auto",
    }));

    setOption(option as EChartsOption);
  };

  useLayoutEffect(() => {
    if (visibleKeys.includes(id)) {
      initOptionFn();
    }
  }, [dataSource, visibleKeys]);

  useLayoutEffect(() => {
    initChart();
  }, [option]);

  return (
    <div className='chart-wrapper'>
      <div id={id} style={{ width: width + "px", height: height + "px", border: "1px solid #3264ff" }}></div>
    </div>
  );
};

export default SuperTestBarChart;
